import { Card, CardTitle, Separator } from '@repo/shadcn';

import { CustomerForm } from '@/modules/customers/customer-form/customer.form';
import { useUpdateCustomer } from '@/modules/customers/update-customer/update-customer.hook';

export const UpdateCustomerModal = () => {
    const { onSubmit, isLoading, data, isUpdating, isError } =
        useUpdateCustomer();

    const renderContent = () => {
        if (isLoading) {
            return <div>Loading...</div>;
        }

        if (isError) {
            return <div>Error loading customer data.</div>;
        }

        if (data) {
            const initialValues = {
                name: data.name,
                email: data.email,
                phone_number: data.phone_number,
                address: data.address,
                customer_type: data.customer_type,
            };

            return (
                <CustomerForm
                    onSubmit={onSubmit}
                    isLoading={isUpdating}
                    initialValues={initialValues}
                    isEditMode={true}
                />
            );
        }
    };

    return (
        <Card className={'space-y-4 border-none shadow-none'}>
            <CardTitle>Edit Customer</CardTitle>
            <Separator />
            {renderContent()}
        </Card>
    );
};

UpdateCustomerModal.displayName = 'UpdateCustomerModal';
